import BaseFeature from '../../foundation/base/base';

class ToggleExpand extends BaseFeature {
	constructor(element) {
		super(element);
		this.elm = element;
		this.expandBtn = element.querySelector('[data-expand-button]') || false;
		if (this.expandBtn !== false) {
			this.initDomCache();
			this.init();
		}
	}

	init() {
		this.addClickListener();
	}

	addClickListener() {
		this.expandBtn.addEventListener('click', () => {
			this.expanded = this.elm.hasAttribute('data-expanded');
			this.expanded = !this.expanded;
			this.handleToggle();
		});
	}

	handleToggle() {
		if (this.expanded) {
			this.elm.setAttribute('data-expanded', true);
			this.elm.setAttribute('aria-expanded', true);
			this.expandBtn.innerText = '-';
		} else {
			this.elm.removeAttribute('data-expanded');
			this.elm.setAttribute('aria-expanded', false);
			this.expandBtn.innerText = '+';
		}
	}
}

export default ToggleExpand;
